import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import {
  USER_SEARCH_FETCH,
  USER_SEARCH_ADD_ERROR,
  USER_SEARCH_CLEAR_ERROR,
  PREFIX,
  USER_SEARCH_UPDATE
} from '../constants/actions';
import { getErrors } from './index';

export const INITIALSTATE = {term: '', validationErrors: [], ...asyncDefaults({})};

const searchUser = makeAsyncReducer(USER_SEARCH_FETCH);

const validation = (state, action) => {
  switch(action.type) {
    case USER_SEARCH_UPDATE:
      return Object.assign({}, state, {term: action.payload});
    case USER_SEARCH_ADD_ERROR:
      return Object.assign({}, state, { validationErrors: [...state.validationErrors, ...action.payload] });
    case USER_SEARCH_CLEAR_ERROR:
      return Object.assign({}, state, { validationErrors: [] });
    default:
      return state;
  }
};

export default mergeReducers(INITIALSTATE, PREFIX, searchUser, validation);

// export const getUserSearch = (state) => state.portal.userSearch.data;
export const getUserSearch = () => ({
  firstName: "Jim",
  lastName: "Test",
  email: "blah@blah.com",
  locked: true,
  dataStewardAccess: false,
  apiKey: "03t329934",
  organization: "blah",
  adminAccess: false
});
export const getUserSearchTerm = (state) => state.portal.userSearch.term;
export const getUserSearchErrors = (state) => {
  const errors = [...state.portal.userSearch.validationErrors];
  const fetchErrors = getErrors(state, 'userSearch');
  if(fetchErrors.userSearch) {
    errors.push(fetchErrors.userSearch);
  }
  return errors;
};
